import VideoPlayer from '@zvuk-b2b/react-uikit/ui/VideoPlayer';
import React from 'react';
import styles from '../index.module.scss';

import { VideoPreviewProps } from './types';

export const VideoPreview: React.FC<VideoPreviewProps> = ({ url }) => (
  <div>
    <VideoPlayer
      className={styles.content}
      width="auto"
      height="auto"
      url={url}
      loop={false}
    />
  </div>
);
